<template lang="pug">
form.section(v-on:submit.prevent)
  template(v-if="mode === SEARCH_BY_GYM || mode === SEARCH_BY_GYM_ONLINE")
    b-input(class="lowercase" placeholder="Filter" v-model="filter")
    b-table.display-none-thead(default-sort="name" default-sort-direction="asc" v-bind:bordered="true" v-bind:data="fakeData ? fakeData : filteredData" v-bind:hoverable="true" v-bind:mobile-cards="true" v-bind:narrowed="true" v-bind:selected.sync="selected" v-bind:striped="true" v-on:select="clickSearchUsingGymLocation")
      template(slot-scope="props")
        b-table-column(field="name" sortable) {{props.row.name}}
      template(slot="empty")
        .section
          .content(class="has-text-centered has-text-grey")
            p
              b-icon(icon="frown" size="is-large")
            p Nothing here.
  template(v-else)
    .field
      .label Search for trainers near:
    .buttons
      .button.is-primary(v-if="canGetCurrentLocation" v-on:click="clickSearchUsingCurrentLocation") Current Location
      template(v-for="location in locations")
        .button.is-primary(v-on:click="clickSearchUsingLocation(location)") {{ location.name }}
      .button.is-outlined.is-primary(v-on:click="clickSearchUsingNewLocation") New Location
  client-professional(v-bind:professionalOnlineLocation="professionalOnlineLocation" v-bind:professional="professionalByLocation" v-bind:key="professionalByLocation.id" v-for="professionalByLocation in filteredProfessionalsByLocation")
  comment(v-if="noProfessionalsFound" comment="No trainers found.")
</template>

<script>
import Constants from '@/constants'

import ClientProfessional from '@/components/ClientProfessional.vue'
import Comment from '@/components/Comment.vue'
import EnterNewLocationForm from '@/components/EnterNewLocationForm.vue'

import ApiMixin from '@/mixins/ApiMixin.vue'

export default {
  components: {
    ClientProfessional,
    Comment
  },
  mixins: [
    ApiMixin
  ],
  props: {
    mode: {
      type: String,
      required: true,
      validator: (mode) => [Constants.SEARCH_BY_GYM, Constants.SEARCH_BY_GYM_ONLINE, Constants.SEARCH_BY_LOCATION].includes(mode)
    }
  },
  data () {
    return {
      fakeData: null,
      filter: '',
      professionalsByLocation: [],
      selected: null
    }
  },
  computed: {
    canGetCurrentLocation () {
      return 'geolocation' in navigator
    },
    filteredData () {
      var lowerCaseFilter = this.filter.toLowerCase()
      return this.selectLocations.filter((element) => {
        for (var property in element) {
          var value = element[property]
          if (value !== null && typeof value === 'string' && value.toString().toLowerCase().includes(lowerCaseFilter)) {
            return true
          }
        }
      })
    },
    filteredProfessionalsByLocation () {
      if (this.mode === Constants.SEARCH_BY_GYM_ONLINE) {
        return this.professionalsByLocation.filter((professional) => this.onlineProfessionals.map((professional) => professional.id).includes(professional.id))
      } else {
        return this.professionalsByLocation
      }
    },
    locations () {
      return this.apiLocations.filter((location) => this.apiClient.locations.includes(location.id)).filter((location) => location.site_ref !== 'ONLINE')
    },
    noProfessionalsFound () {
      return this.filteredProfessionalsByLocation.length === 0
    },
    onlineLocation () {
      return this.apiLocations.filter((location) => location.name.startsWith(this.operatorName) && location.site_ref).find((location) => location.site_ref === 'ONLINE')
    },
    onlineProfessionals () {
      return this.apiProfessionals.filter((professional) => professional.locations.map((location) => location.id).includes(this.onlineLocation.id))
    },
    professionalOnlineLocation () {
      return this.mode === Constants.SEARCH_BY_GYM_ONLINE ? this.onlineLocation.id : null
    },
    selectLocations () {
      return this.apiLocations.filter((location) => location.name.startsWith(this.operatorName) && location.site_ref).filter((location) => location.site_ref !== 'ONLINE')
    }
  },
  created () {
    this.SEARCH_BY_GYM = Constants.SEARCH_BY_GYM
    this.SEARCH_BY_GYM_ONLINE = Constants.SEARCH_BY_GYM_ONLINE
    this.SEARCH_BY_LOCATION = Constants.SEARCH_BY_LOCATION
  },
  mounted () {
    this.initialiseFakeData()
  },
  methods: {
    async clickSearchUsingCurrentLocation () {
      navigator.geolocation.getCurrentPosition(async (position) => {
        await this.searchUsingLatLng(position.coords.latitude, position.coords.longitude, 'current location')
      })
    },
    async clickSearchUsingGymLocation (location) {
      await this.searchUsingLatLng(location.lat, location.lng, location.name, 0.01)
    },
    async clickSearchUsingLocation (location) {
      await this.searchUsingLatLng(location.lat, location.lng, location.name)
    },
    async searchUsingLatLng (lat, lng, name = 'lat/lng', range = 10) {
      this.professionalsByLocation = await this.apiGetProfessionalsByLocation(lat, lng, name, range)
    },
    clickSearchUsingNewLocation () {
      this.$buefy.modal.open({
        component: EnterNewLocationForm,
        hasModalCard: true,
        parent: this,
        props: {
          impl: this.enterNewLocationFormImpl,
          initialLocation: '',
          noun: 'Location',
          verbBase: 'Enter',
          verbGerund: 'Entering'
        }
      })
    },
    async enterNewLocationFormImpl (name, place, range, save) {
      if (save) {
        let location = {
          address: place.formatted_address,
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
          name: place.name,
          postcode: place.address_components.filter((addressComponent) => addressComponent.types.includes('postal_code')).reduce((accumulator, addressComponent) => addressComponent.long_name, null)
        }
        location = await this.apiCreateLocation(location, true)
        await this.apiCreateClientLocation(this.apiUserId, location.id, location.name, 100)
      }
      await this.searchUsingLatLng(place.geometry.location.lat(), place.geometry.location.lng(), place.name)
    },
    initialiseFakeData () {
      this.fakeData = [{ id: 0 }]
      this.$nextTick(() => {
        this.fakeData = null
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.b-table
  margin-top: 1rem
  margin-bottom: 1rem
  td
    cursor: pointer
    display: block !important
    text-align: left !important
</style>
